<template>
    <div class="menu-button">
        <div class="wp-block-diode-blocks-button">
            <a class="filled" href="/auth">
                {{ $publicDico.header.button.label }}
            </a>
        </div>
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    props: ["userInitialName", "userPermission"],
    components: {},
    computed: {
        dico() {
            return this.$publicDico;
        },
    },
});
</script>

<style lang="sass" scoped>
.menu-button
    display: flex
    align-items: center
    +r(1140)
        margin-top: 16px

.wp-block-diode-blocks-button
    display: flex
    align-items: center

    a
        padding: 10px 20px
        text-decoration: none
        box-shadow: 0px 3px 6px rgb(0 0 0 / 16%)
        line-height: 18px
        font-weight: 700
        +r(900)
            font-size: 20px

    .filled
        background-color: $color-main
        color: #fff
        border: 1px solid $color-main
        transition: all 0.15s ease
        &:hover
            background-color: $color-secondary
            border-color: $color-secondary
            color: white
</style>
